import { HomePage } from './components/HomePage/HomePage';
import './styles/main.scss'

export const App = () => {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}
